import { RouteSuggestion } from '@/javascript/domain/entities/route-suggestion'
import { useState } from 'react'

const useRoutingSuggestions = () => {

  const [routeSuggestions, setRouteSuggestions] = useState<RouteSuggestion[]>([])
  const [unassignedWorkIds, setUnassignedWorkIds] = useState<number[]>([])
  const [unassignedMemberIds, setUnassignedMemberIds] = useState<number[]>([])
  const [selectionError, setSelectionError] = useState<{message: string, reason?: string, references?: number[], unassignedMemberIds?: number[]}>()

  return { routeSuggestions, setRouteSuggestions, unassignedWorkIds, setUnassignedWorkIds, unassignedMemberIds, setUnassignedMemberIds, selectionError, setSelectionError }
}

export default useRoutingSuggestions
